import React, { useEffect, useState } from 'react';
import { fetchUserPathwaysData } from './useStudioAuthoringPathways';
import { getTenant, getUserId } from '@acilearning/ibl-web-react-common';
import { useDebounce } from './useDebounce';

const usePathways = ({ search = '', refresher = null }) => {
  const [pathways, setPathways] = useState([]);
  const [filteredPathways, setFilteredPathways] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleFetchPathways = () => {
    const userId = getUserId();
    const tenant = getTenant();
    setLoading(true);
    fetchUserPathwaysData(
      tenant,
      userId,
      (response) => {
        const result = Array.isArray(response) ? response : [];
        console.log('response pathway', result);
        setPathways(result);
        setFilteredPathways(result);
        setLoading(false);
      },
      () => {
        setPathways([]);
        setFilteredPathways([]);
        setLoading(false);
      }
    );
  };

  const handlePathwaysSearch = () => {
    if (search.length > 1) {
      setFilteredPathways(
        pathways.filter((pre) =>
          String(pre?.name).toUpperCase().includes(String(search).toUpperCase())
        )
      );
    } else {
      setFilteredPathways(pathways);
    }
  };

  useDebounce(handlePathwaysSearch, 200, [search]);

  useEffect(() => {
    handleFetchPathways();
  }, [refresher]);

  return {
    loading,
    filteredPathways,
  };
};

export default usePathways;
